import Vue from 'vue';
import { getSwiper, getSwiperModules } from '../utils';

Vue.component('tabslider', {
    data() {
        return {
            tabIndex: 0,
            sectionIndex: 0,
        };
    },

    async mounted() {
        await this.initSwiper();
    },

    methods: {
        switchSection(index) {
            if (index != this.tabIndex) {
                this.tabIndex = index;
                this.sectionIndex = index;

                setTimeout(() => this.initSwiper(), 100);
            }
        },

        async initSwiper() {
            const { Swiper } = await getSwiper();
            const { Pagination } = await getSwiperModules();

            new Swiper('.page-slider', {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                modules: [Pagination],
                centeredSlides: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    renderBullet: (index, className) =>
                        `<span class='${className}'>${index + 1}</span>`,
                },
                uniqueNavElements: true,
                navigation: {
                    nextEl: '.page-slider-next',
                    prevEl: '.page-slider-prev',
                },
            });
        },
    },
});
